export const getDomainName = () => {
  if (typeof window === "undefined") {
    return undefined;
  }
  const host = window.location.hostname;

  switch (true) {
    case host.includes("ayana.com"):
      return "ayana.com";
    case host.includes("gatsbyjs.io"):
      return "gatsbyjs.io";
    case host.includes("vercel.app"):
      return "";
    case host.includes("gtsb.io"):
      return "gtsb.io";
    case host.includes("netlify.app"):
      return "";
    case host.includes("localhost"):
      return "";
    default:
      return undefined;
  }
};
